import { Suspense } from "react";
import { useAtomValue } from "jotai";
import { Tag } from "@zapier/design-system";
import { formsSubmissionsAsyncAtomFamily } from "@zapier/canvas-state";

type Props = {
  nodeId: string;
  interfaceProjectId: string;
  interfacePageId: string;
};

function SuspendedInterfaceFormsStatus({
  nodeId,
  interfaceProjectId,
  interfacePageId,
}: Props) {
  const formSubmissions = useAtomValue(
    formsSubmissionsAsyncAtomFamily({
      nodeId,
      interfaceProjectId,
      interfacePageId,
    }),
  );

  if (formSubmissions !== null && formSubmissions.total === 0) {
    return (
      <Tag variant="warning" size="small">
        No submissions
      </Tag>
    );
  }

  return null;
}

export function InterfaceFormsStatus({
  nodeId,
  interfaceProjectId,
  interfacePageId,
}: Props) {
  return (
    <Suspense fallback={null}>
      <SuspendedInterfaceFormsStatus
        nodeId={nodeId}
        interfaceProjectId={interfaceProjectId}
        interfacePageId={interfacePageId}
      />
    </Suspense>
  );
}
